import { RouteID } from "../../routing/routes";
import { googleAnalyticsCustomEvent } from "../../sharedUtilities/analytics";
import { Side, InnerUl, InnerLi, HeaderNavigationListItem } from "./styles";
import { LinkMetadataItemProps } from "./Utils";
import { useState } from "react";
import { Link } from "react-router";

interface FlyoutMenuItemProps {
  route: string;
  routeId: RouteID;
  label: string;
  subMenuItems: LinkMetadataItemProps[] | undefined;
}

const flyoutDirectionMap = new Map<RouteID, Side>([
  [RouteID.CountryProfiles, Side.Left],
  [RouteID.DataDownloads, Side.Right],
  // [RouteID.KeyConcepts, Side.Right],
  [RouteID.About, Side.Right],
]);

const FlyoutMenuItem = ({
  routeId,
  route,
  label,
  subMenuItems,
}: FlyoutMenuItemProps) => {
  let [isOpen, setIsOpen] = useState<boolean>(false);

  const handleMouseEnter = () => setIsOpen(true);
  const handleMouseLeave = () => setIsOpen(false);
  let highlightClassName: string | null;

  let flyout: React.ReactElement | null;
  if (isOpen && subMenuItems) {
    highlightClassName = "highlight";

    const flyoutDirection = flyoutDirectionMap.get(routeId) as Side;
    flyout = (
      <InnerUl side={flyoutDirection}>
        {subMenuItems.map(({ route, label }, index) => (
          <InnerLi key={index}>
            <Link to={route}>{label}</Link>
          </InnerLi>
        ))}
      </InnerUl>
    );
  } else {
    highlightClassName = null;
    flyout = null;
  }

  let outerMenuLink: any;
  if (routeId === RouteID.Learn) {
    // Learn menu has no direct link, just a dropdown trigger
    outerMenuLink = <span>{label}</span>;
  } else {
    outerMenuLink = (
      <Link
        to={route}
        onClick={() =>
          googleAnalyticsCustomEvent(
            "nav",
            "click",
            label.split(" ").join("-"),
            "topnav",
          )
        }
      >
        {label}
      </Link>
    );
  }

  return (
    <>
      <HeaderNavigationListItem
        className={highlightClassName ? highlightClassName : ""}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {outerMenuLink}
        {flyout}
      </HeaderNavigationListItem>
    </>
  );
};

export default FlyoutMenuItem;
